import React from 'react'
import { AiOutlineTwitter } from "react-icons/ai"
import { BsLinkedin } from "react-icons/bs"
import { BsGithub } from "react-icons/bs"
import { FaInstagramSquare } from "react-icons/fa"
import "./Footer.css"

const Footer = () => {
    return (
        <footer id='Footer'>
            <div className='max-w-7xl justify-between mx-auto flex'>
                <div className='links flex space-x-4'>
                    <a target="_blank" href="https://twitter.com/Uticodes"><AiOutlineTwitter /></a>
                    <a target="_blank" href="https://www.linkedin.com/in/utibe-etim-0a901a107/"><BsLinkedin /></a>
                    <a target="_blank" href="https://github.com/Uticodes"><BsGithub /></a>
                    <a target="_blank" href="https://github.com/Uticodes"><FaInstagramSquare /></a>
                </div>
                <div className='md:block hidden'>
                    <small>Design by Sanchez</small>
                </div>
            </div>
        </footer>
    )
}

export default Footer
